
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire36c3"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire36c3"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("awTFk", function(module, exports) {

$parcel$export(module.exports, "register", () => $7aa812910441b77c$export$6503ec6e8aabbaf, (v) => $7aa812910441b77c$export$6503ec6e8aabbaf = v);
var $7aa812910441b77c$export$6503ec6e8aabbaf;
var $7aa812910441b77c$export$f7ad0328861e2f03;
"use strict";
var $7aa812910441b77c$var$mapping = new Map();
function $7aa812910441b77c$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$7aa812910441b77c$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $7aa812910441b77c$var$resolve(id) {
    var resolved = $7aa812910441b77c$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$7aa812910441b77c$export$6503ec6e8aabbaf = $7aa812910441b77c$var$register;
$7aa812910441b77c$export$f7ad0328861e2f03 = $7aa812910441b77c$var$resolve;

});

parcelRegister("foZcB", function(module, exports) {
module.exports = new URL("../../aqua-cleaner-items-1.6d277587.webp", import.meta.url).toString();

});

parcelRegister("h7azu", function(module, exports) {
module.exports = new URL("../../aqua-cleaner-items-2.b807db55.webp", import.meta.url).toString();

});

parcelRegister("km9sG", function(module, exports) {
module.exports = new URL("../../aqua-cleaner-items-3.6881a0d7.webp", import.meta.url).toString();

});

parcelRegister("gqvjz", function(module, exports) {
module.exports = new URL("../../aqua-cleaner-items-4.e6f91e0e.webp", import.meta.url).toString();

});

parcelRegister("88hYg", function(module, exports) {
module.exports = new URL("../../aqua-cleaner-items-5.da4f759c.webp", import.meta.url).toString();

});

parcelRegister("gCutc", function(module, exports) {
module.exports = new URL("../../aqua-cleaner-items-6.f6eac2fd.webp", import.meta.url).toString();

});

parcelRegister("ldZaW", function(module, exports) {
module.exports = new URL("../../aqua-cleaner-items-7.163fcba0.webp", import.meta.url).toString();

});

parcelRegister("c4Z8w", function(module, exports) {
module.exports = new URL("../../aqua-cleaner-items-8.b0d82a85.webp", import.meta.url).toString();

});

parcelRegister("gaJxt", function(module, exports) {
module.exports = new URL("../../aqua-cleaner-items-9.193973aa.webp", import.meta.url).toString();

});

var $76bdca8ffcda2aea$exports = {};

(parcelRequire("awTFk")).register(new URL("", import.meta.url).toString(), JSON.parse('["4rfx4","index.76bc653d.js","gLzNX","../../aqua-cleaner-items-1.6d277587.webp","5cRm6","../../aqua-cleaner-items-2.b807db55.webp","7DsLb","../../aqua-cleaner-items-3.6881a0d7.webp","kBPVw","../../aqua-cleaner-items-4.e6f91e0e.webp","acOvt","../../aqua-cleaner-items-5.da4f759c.webp","89WL2","../../aqua-cleaner-items-6.f6eac2fd.webp","447OQ","../../aqua-cleaner-items-7.163fcba0.webp","gu31G","../../aqua-cleaner-items-8.b0d82a85.webp","cUcQn","../../aqua-cleaner-items-9.193973aa.webp","dClOW","../../index.ab349918.js","g9YeP","index.d2b8160f.css"]'));


var $cTYCN = parcelRequire("cTYCN");

window.Alpine = (0, $cTYCN.default);









(0, $cTYCN.default).data("carousel", ()=>({
        activeSlide: 1,
        slides: [
            {
                image: (parcelRequire("foZcB")),
                title: "Bico Extrator Grande"
            },
            {
                image: (parcelRequire("h7azu")),
                title: "Bico Extrator Pequeno"
            },
            {
                image: (parcelRequire("km9sG")),
                title: "Bico M\xfaltiplo com Escova"
            },
            {
                image: (parcelRequire("gqvjz")),
                title: "Filtro Espuma"
            },
            {
                image: (parcelRequire("88hYg")),
                title: "Bico Escova"
            },
            {
                image: (parcelRequire("gCutc")),
                title: "Extens\xe3o Telesc\xf3pica em Alum\xednio"
            },
            {
                image: (parcelRequire("ldZaW")),
                title: "Rodo Remov\xedvel"
            },
            {
                image: (parcelRequire("c4Z8w")),
                title: "Bico Canto"
            },
            {
                image: (parcelRequire("gaJxt")),
                title: "Mangueira de 2,3m com Gatilho Spray"
            }
        ],
        previous () {
            if (this.activeSlide > 1) this.activeSlide -= 1;
            else this.activeSlide = this.slides.length;
        },
        next () {
            if (this.activeSlide < this.slides.length) this.activeSlide += 1;
            else this.activeSlide = 1;
        }
    }));
// Swiper
const $132cf3215e9f7d85$var$swiperEl = document.querySelector("swiper-container");
const $132cf3215e9f7d85$var$swiperParams = {
    slidesPerView: 1,
    slidesPerGroup: 1,
    pagination: false,
    loop: true,
    breakpoints: {
        640: {
            slidesPerView: 2,
            slidesPerGroup: 2,
            pagination: false
        },
        1024: {
            slidesPerView: 3,
            slidesPerGroup: 3,
            pagination: false
        }
    },
    injectStyles: [
        `
      .swiper-button-next,
      .swiper-button-prev {
        background-color: rgb(210 213 219);
        padding: 8px 16px;
        border-radius: 100%;
        border: 0;
        color: white;
      }
      .swiper-button-next {
        padding-left: 18px;
      }
      .swiper-button-prev {
        padding-right: 18px;
      }
      .swiper-button-next > svg,
      .swiper-button-prev > svg {
        transform: scale(0.65);
      }
  `
    ],
    on: {
        init () {
        // ...
        }
    }
};
Object.assign($132cf3215e9f7d85$var$swiperEl, $132cf3215e9f7d85$var$swiperParams);
if ($132cf3215e9f7d85$var$swiperEl) $132cf3215e9f7d85$var$swiperEl.initialize();
(0, $cTYCN.default).start();
let $132cf3215e9f7d85$var$interval;
function $132cf3215e9f7d85$var$sendHeight() {
    if (document.getElementById("lp")) {
        const height = document.body.scrollHeight;
        window.parent.postMessage({
            frameHeight: height
        }, "*");
    } else {
        clearInterval($132cf3215e9f7d85$var$interval);
        $132cf3215e9f7d85$var$interval = null;
    }
}
// Send the height when the DOM is fully loaded
document.addEventListener("DOMContentLoaded", $132cf3215e9f7d85$var$sendHeight);
// Update the height at an interval
$132cf3215e9f7d85$var$interval = setInterval($132cf3215e9f7d85$var$sendHeight, 500);
// Optionally, update the height when the window is resized
window.addEventListener("resize", $132cf3215e9f7d85$var$sendHeight);


//# sourceMappingURL=index.76bc653d.js.map
